var _excluded = ["isOpen", "selectedItem", "renderInput", "itemToString", "renderPlaceholder", "renderItem", "getToggleButtonProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { defaultLabelGetter } from '../../helpers/defaultGetters';
import ControlLabel from './ControlLabel';
import Placeholder from './Placeholder';
import Selected from './Selected';

var Control = function Control(_ref) {
  var _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$selectedItem = _ref.selectedItem,
      selectedItem = _ref$selectedItem === void 0 ? null : _ref$selectedItem,
      renderInput = _ref.renderInput,
      _ref$itemToString = _ref.itemToString,
      itemToString = _ref$itemToString === void 0 ? function (item) {
    return defaultLabelGetter(item);
  } : _ref$itemToString,
      _ref$renderPlaceholde = _ref.renderPlaceholder,
      renderPlaceholder = _ref$renderPlaceholde === void 0 ? function () {
    return /*#__PURE__*/React.createElement(Placeholder, null);
  } : _ref$renderPlaceholde,
      _ref$renderItem = _ref.renderItem,
      renderItem = _ref$renderItem === void 0 ? function () {
    return /*#__PURE__*/React.createElement(Selected, null, itemToString(selectedItem));
  } : _ref$renderItem,
      getToggleButtonProps = _ref.getToggleButtonProps,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ControlLabel, _extends({
    isOpen: isOpen,
    getToggleButtonProps: getToggleButtonProps
  }, props), renderInput && renderInput(), selectedItem && renderItem({
    selectedItem: selectedItem,
    itemToString: itemToString,
    isOpen: isOpen
  }), !selectedItem && renderPlaceholder());
};

Control.displayName = 'Control';
Control.propTypes = _objectSpread({}, ControlLabel.propTypes);
export default Control;
//# sourceMappingURL=Control.js.map